var _a;
import { createStateContext } from '../../helpers/context';
export var ErrorProvider = (_a = createStateContext({}), _a.Provider), useError = _a.useContext;
//# sourceMappingURL=context.js.map